import { Timestamp } from 'firebase/firestore';

export enum WebsiteStatus {
  CREATED = 'created',
  SCRAPED = 'scraped',
  LANGUAGE_DETECTED = 'language detected',
  DESCRIPTION_CREATED = 'description created',
  METADATA_ANALYZED = 'metadata analyzed',
  EXTRACTING = 'extracting',
  ANALYZING = 'analyzing',
  DONE = 'done',
  ERROR = 'error',
  HIDDEN = 'hidden',
}

export interface Website {
  id: string;
  url: string;
  userId: string;
  status: string;
  hTagsCount?: number;
  imageCount?: number;
  linksCount?: number;
  createdAt: Timestamp;
  updatedAt: Timestamp;
  llmLanguage?: string;
  llmDescription?: string;
  llmKeywords?: string[];
  llmTargetAudience?: string;
}

export interface WebsiteImage {
  id: string;
  alt: string;
  llmAlt: string;
  src: string;
  normalizedSrc: string;
  title: string;
  llmTitle: string;
  llmReason: string;
  xpath: string;
  updatedAt: Timestamp;
  originalFormat: string;
  originalDimensions: number[];
  status: string;
}
